import { createContext, useContext, useEffect } from "react";

const MenuContext = createContext({
    // Temporarily collapses the main menu without changing the user's own collapse preference
    setForceCollapsed: () => {},
});

// Keeps the main menu collapsed while `active` is true, then restores it to its previous state
export const useForceMenuCollapsed = (active) => {
    const { setForceCollapsed } = useContext(MenuContext);

    useEffect(() => {
        if (!active) return;
        setForceCollapsed(true);
        return () => setForceCollapsed(false);
    }, [active, setForceCollapsed]);
};

export default MenuContext;
